/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import JsonView from '@uiw/react-json-view';
import { lightTheme } from '@uiw/react-json-view/light';

export default function JsonViewer({ json }: { json: object }) {
  return (
    <div
      css={css`
        max-height: 600px;
        overflow: auto;
      `}
    >
      <JsonView
        value={json}
        style={lightTheme}
        collapsed={1}
        displayDataTypes={false}
        displayObjectSize={true}
        enableClipboard={false}
      />
    </div>
  );
}
